
export class LocationWiseDto {
    locationId?: number;
    locationName? : string;
    plant?: number;
    plantId?: number;


    constructor( locationId?: number,
        locationName? : string,
        plant?: number,
        plantId?: number,
        

    ) {this.locationId =locationId
        this.locationName =locationName
        this.plant =plant
        this.plantId =plantId
       
    }

}
